import { render, staticRenderFns } from "./MonthlyRanking.vue?vue&type=template&id=4be389c1&scoped=true&"
import script from "./MonthlyRanking.vue?vue&type=script&lang=js&"
export * from "./MonthlyRanking.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyRanking.vue?vue&type=style&index=0&id=4be389c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be389c1",
  null
  
)

export default component.exports